import IpubTable from './src/main'

/* istanbul ignore next */
IpubTable.install = function(Vue) {
  Vue.component(IpubTable.name, IpubTable)
}

export default IpubTable
